import { useMutation, useQueryClient } from '@tanstack/react-query';

import { integrationsApi } from '../api';

interface UseInitCalendlyParams {
  userId: string;
  code: string;
  codeVerifier: string;
}

export function useInitCalendly() {
  const queryClient = useQueryClient();

  const initCalendlyMutation = useMutation({
    mutationFn: ({ userId, code, codeVerifier }: UseInitCalendlyParams) => {
      return integrationsApi.initCalendly(userId, { code, codeVerifier });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.integration.calendly'] });
      queryClient.invalidateQueries({ queryKey: ['lifestack.user'] });
    },
  });

  return {
    initCalendly: initCalendlyMutation.mutateAsync,
    ...initCalendlyMutation,
  };
}
